import { CloseIcon } from '@chakra-ui/icons';
import { Badge, Box } from '@chakra-ui/react';
import { api } from '../../../../../services/api';
import { useMutation, useQueryClient } from 'react-query';

async function deleteTagFn({ id }) {
  const response = await api.delete('/site/v2/atualizacao-seo-categoria/excluir-tag-segmento', {
    data: { id }
  });

  return response.data;
}

export function TagItem({ tag }) {
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: deleteTagFn,
    onSuccess: () => {
      queryClient.invalidateQueries('registeredSegmento');
    }
  });

  async function handleDeleteTag() {
    await mutateAsync({ id: tag.id });
  }

  return (
    <Box position="relative">
      <CloseIcon
        position="absolute"
        top={0}
        right={'-1'}
        cursor="pointer"
        fontSize="9px"
        borderRadius="50%"
        bg="gray.100"
        boxShadow="md"
        color="red.500"
        onClick={handleDeleteTag}
      />

      <Badge variant="outline" colorScheme="blue">
        {tag.tag}
      </Badge>
    </Box>
  );
}
